<template>
  <div v-if="dataRecieved">
    <ImagePopup
      v-if="imagePopup"
      :show="imagePopup"
      :image="selectedImage"
      @close="imagePopup = false"
    ></ImagePopup>

    <div class="vx-card mt-10">
      <div class="vx-card__body card-body p-10">
        <div class="flex flex-col">
          <div class="w-full mb-10 ">
            <vs-button
             v-if="expenseDetails.expenseStateQuery === 1"
              type="filled"
              id="l-confirm-btn"
              v-has-permission="'ChangeStateToConfirm'"
              class="float-right purple mx-2 z-50"
              @click.prevent="confirm(expenseDetails.id)"
              >{{ $t("Confirm") }}</vs-button
            >
          </div>
        </div>
        <div class="mb-4 flex gap-5">
          <div class="vx-col w-full mb-4 lg:w-1/2">
            <div class="vx-card mb-4 user-info">
              <div class="vx-card__header">
                <div class="vx-card__title">
                  <h4>{{ $t("Payer") }}</h4>
                </div>
              </div>
              <div
                class="vx-card__collapsible-content vs-con-loading__container"
              >
                <div class="vx-card__body custom-tbl v-table">
                  <vs-table :data="expenseDetails.payerInfoQuery" ref="table">
                    <template :name="{ data }" slot-scope="{ data }">
                      <vs-tr>
                        <vs-td class="w-1/3 text-right pr-12">
                          {{ $t("Account") }}
                        </vs-td>
                        <vs-td>
                          {{ expenseDetails.payerInfoQuery?expenseDetails.payerInfoQuery.accountName :''}}
                        </vs-td>
                      </vs-tr>
                      <vs-tr>
                        <vs-td class="w-1/3 text-right pr-12">
                          {{ $t("AccountCode") }}
                        </vs-td>
                        <vs-td style="direction: ltr">
                          {{ expenseDetails.payerInfoQuery?expenseDetails.payerInfoQuery.accountCode:'' }}
                        </vs-td>
                      </vs-tr>
                      <vs-tr>
                        <vs-td class="w-1/3 text-right pr-12">
                          {{ $t("AccountFloating") }}
                        </vs-td>
                        <vs-td>
                          {{
                            expenseDetails.payerInfoQuery && expenseDetails.payerInfoQuery.floatingAccountName
                              ? expenseDetails.payerInfoQuery
                                  .floatingAccountName
                              : "-"
                          }}
                        </vs-td>
                      </vs-tr>
                      <vs-tr>
                        <vs-td class="w-1/3 text-right pr-12">
                          {{ $t("AccountFloatingCode") }}
                        </vs-td>
                        <vs-td style="direction: ltr">
                          {{
                            expenseDetails.payerInfoQuery && expenseDetails.payerInfoQuery.floatingAccountCode
                              ? expenseDetails.payerInfoQuery
                                  .floatingAccountCode
                              : "-"
                          }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col w-full mb-4 lg:w-1/2">
            <div class="vx-card mb-4 user-info">
              <div class="vx-card__header">
                <div class="vx-card__title">
                  <h4>{{ $t("Receiver") }}</h4>
                </div>
              </div>
              <div
                class="vx-card__collapsible-content vs-con-loading__container"
              >
                <div class="vx-card__body custom-tbl v-table">
                  <vs-table
                    :data="expenseDetails.receiverInfoQuery"
                    ref="table"
                  >
                    <template :name="{ data }" slot-scope="{ data }">
                      <vs-tr>
                        <vs-td class="w-1/3 text-right pr-12">
                          {{ $t("Account") }}
                        </vs-td>
                        <vs-td>
                          {{ expenseDetails.receiverInfoQuery?expenseDetails.receiverInfoQuery.accountName:'' }}
                        </vs-td>
                      </vs-tr>
                      <vs-tr>
                        <vs-td class="w-1/3 text-right pr-12">
                          {{ $t("AccountCode") }}
                        </vs-td>
                        <vs-td style="direction: ltr">
                          {{ expenseDetails.receiverInfoQuery?expenseDetails.receiverInfoQuery.accountCode:'' }}
                        </vs-td>
                      </vs-tr>
                      <vs-tr>
                        <vs-td class="w-1/3 text-right pr-12">
                          {{ $t("AccountFloating") }}
                        </vs-td>
                        <vs-td>
                          {{
                            expenseDetails.receiverInfoQuery && expenseDetails.receiverInfoQuery.floatingAccountName
                              ? expenseDetails.receiverInfoQuery
                                  .floatingAccountName
                              : "-"
                          }}
                        </vs-td>
                      </vs-tr>
                      <vs-tr>
                        <vs-td class="w-1/3 text-right pr-12">
                          {{ $t("AccountFloatingCode") }}
                        </vs-td>
                        <vs-td style="direction: ltr">
                          {{
                            expenseDetails.receiverInfoQuery && expenseDetails.receiverInfoQuery.floatingAccountCode
                              ? expenseDetails.receiverInfoQuery
                                  .floatingAccountCode
                              : "-"
                          }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col w-full mb-4 lg:w-1/3">
          <div class="vx-card mb-4 user-info">
            <div class="vx-card__header">
              <div class="vx-card__title">
                <h4>{{ $t("Details") }}</h4>
              </div>
            </div>
            <div class="vx-card__collapsible-content vs-con-loading__container">
              <div class="vx-card__body custom-tbl v-table">
                <vs-table :data="expenseDetails" ref="table">
                  <template :name="{ data }" slot-scope="{ data }">
                    <vs-tr>
                      <vs-td class="w-1/3 text-right pr-12">
                        {{ $t("Fee") }}
                      </vs-td>
                      <vs-td>
                        {{ expenseDetails.amount }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="w-1/3 text-right pr-12">
                        {{ $t("CreateOn") }}
                      </vs-td>
                      <vs-td>
                        {{
                          expenseDetails.createOn
                            ? expenseDetails.createOn
                            : "-"
                        }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="w-1/3 text-right pr-12">
                        {{ $t("Description") }}
                      </vs-td>
                      <vs-td>
                        {{
                          expenseDetails.description
                            ? expenseDetails.description
                            : "-"
                        }}
                      </vs-td>
                    </vs-tr>
                    <vs-tr>
                      <vs-td class="w-1/3 text-right pr-12">
                        {{ $t("Status") }}
                      </vs-td>
                      <vs-td>
                        {{
                          expenseDetails.expenseStateQuery === 1
                            ? 'در حال بررسی'
                            : "تایید شده"
                        }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <h4 class="mt-5 mr-5">        {{ $t("Attachment") }}
        </h4>
        <div class="flex flex-row flex-wrap mt-5">
          <div v-if="imageAttached && imageAttached.length === 0">
            {{ $t("NoRecordsFound") }}
          </div>
          <div v-for="row in imageAttached" class="">
            <div class="border-solid p-5 m-5">
              <img
                :src="
                  URLS_CONSTANTS.assets + 'PettyCashTransactions/' + row.uri
                "
                style="max-height: 100px"
                class="rounded cursor-pointer"
                @click.prevent="
                  showImagePopup(
                    URLS_CONSTANTS.assets + 'PettyCashTransactions/' + row.uri
                  )
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { URLS_CONSTANTS } from "@/../config";
import ImagePopup from "@/components/ImagePopup.vue";

export default {
  data() {
    return {
      popupTitle: "",
      modelToEdit: this.$route.params.id,
      expenseDetails: {},
      uploadPopup: false,
      URLS_CONSTANTS,
      imagePopup: false,
      modelToEdit: this.$route.params.id,
      imageAttached: [],
      dataRecieved:false,
    };
  },
  components: {
    ImagePopup,
  },
  mounted() {
    this.getData();
    this.dataRecieved=true
  },
  methods: {
    ...mapActions({
      fetchDetails: "pettyCash/fetchExpenseInfoById",
      fetchAttachment: "pettyCash/fetchAttachment",
      confirmExpense: "pettyCash/confirmExpense",
    }),
    getData() {
      this.fetchDetails(this.modelToEdit).then((result) => {
        this.expenseDetails = result;
      });
      this.fetchAttachment(this.modelToEdit).then((result) => {
        this.imageAttached = result;
      });
    },
    showImagePopup(image) {
      this.selectedImage = image;
      this.imagePopup = true;
    },
    confirm(id){
      var payload={
        expenseId:id
      }
      this.confirmExpense(payload).then(() => {
            this.$router.go(-1);
          });
    }
  },
};
</script>
